var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.1974C16.2132 13.8069 17.2534 14.785 18.0127 16.008C18.163 16.2503 18.2382 16.3713 18.2642 16.539C18.317 16.8798 18.084 17.2988 17.7666 17.4337C17.6104 17.5 17.4347 17.5 17.0833 17.5M13.3333 9.61017C14.5681 8.99658 15.4167 7.72238 15.4167 6.25C15.4167 4.77762 14.5681 3.50343 13.3333 2.8898M11.6667 6.25C11.6667 8.32107 9.98767 10 7.91663 10C5.84557 10 4.16663 8.32107 4.16663 6.25C4.16663 4.17893 5.84557 2.5 7.91663 2.5C9.98767 2.5 11.6667 4.17893 11.6667 6.25ZM2.13266 15.7819C3.46125 13.7872 5.55777 12.5 7.91663 12.5C10.2755 12.5 12.372 13.7872 13.7006 15.7819C13.9917 16.219 14.1372 16.4375 14.1204 16.7166C14.1074 16.9339 13.9649 17.2 13.7912 17.3313C13.5682 17.5 13.2615 17.5 12.648 17.5H3.18527C2.57177 17.5 2.26503 17.5 2.042 17.3313C1.86834 17.2 1.72587 16.9339 1.71282 16.7166C1.69607 16.4375 1.8416 16.219 2.13266 15.7819Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/visitor.de900c92b1f7001fae970b08ed8ce2a5.svg";
export { ForwardRef as ReactComponent };